module.exports = __webpack_public_path__ + "static/img/img-5.ff17e953.png";